import { Backdrop, Button, Paper, styled } from "@mui/material";
import React from "react";
import colors from "../../../theme/themeConstants";

interface IProps {
  isOpen: boolean;
  togglePopup: () => void;
  handleDelete: () => void;
  collectionName: string | null | undefined;
}

export const DeleteCollectionPopup = ({ isOpen, togglePopup, handleDelete, collectionName }: IProps) => {

  const handleStopPropagation = (event: React.MouseEvent) => {
    event.stopPropagation();
  };

  return (
    <Backdrop open={isOpen} id={"popupOpen"}
      sx={{
        zIndex: 32
      }}
      onClick={togglePopup}
    >
      <Paper onClick={handleStopPropagation} sx={{
        margin: "0 1rem",
        borderRadius: "24px",
        padding: "2rem 30px",
        paddingTop: "40px"
      }}>
        <p style={{ textAlign: "center" }}>
          Are you sure want to delete&nbsp;
          your <b>{collectionName}</b> collection?
        </p>
        <DeleteButton
          onClick={handleDelete}
          variant="outlined"
          fullWidth
          sx={{
            marginTop: "2rem",
            marginBottom: "1rem"
          }}
        > Yes, delete
        </DeleteButton>

        <Button onClick={togglePopup} fullWidth sx={{
          border: "none",
          color: "black",
          textDecoration: "underline",
          background: "transparent",
          ":hover": {
            border: "none",
            background: "none",
          },
          margin: "0"
        }}>
          Cancel
        </Button>
      </Paper>
    </Backdrop >
  );
};

const DeleteButton = styled(Button)({
  height: "52px",
  maxWidth: "83vw",
  margin: "1.5rem 0",
  borderRadius: "38px",
  background: colors.purpleGradient,
  border: `1px solid ${colors.purple}`,
  color: "white",
  ":hover": { border: `1px solid ${colors.purple}` }
});
